'use client'

import type { PublicationDraft } from '@/lib/publications/types'
import {
  Badge,
  FullBleedImage,
  HandmadeFrame,
  SafeText,
  clampIndex,
  getCopy,
  getDesign,
  getSectorFonts,
  getVisual,
  type HandmadePackProps,
} from '../shared/HandmadePackCore'

const images = ['https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1551836022-d5d88e9218df?q=80&w=1200&auto=format&fit=crop','https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=1200&auto=format&fit=crop']

const fallbackSlides = [{eyebrow:'PREGUNTA',headline:'¿Cuál de estos eres tú?',subheadline:'Una pieza para abrir conversación y activar participación.',cta:'Responder',bullets:['Opción A', 'Opción B', 'Opción C']},{eyebrow:'DINÁMICA',headline:'Elige tu punto de partida',subheadline:'Haz que la audiencia se vea dentro del contenido.',cta:'Comentar',bullets:['Nivel 1', 'Nivel 2', 'Nivel 3']},{eyebrow:'CIERRE',headline:'Tu respuesta define el siguiente paso',subheadline:'Convierte conversación en acción ligera.',cta:'Unirme',bullets:['Comunidad', 'Reto', 'Seguimiento']}]

export default function CorporateCommunityPack({ draft, activeIndex, onActiveIndexChange }: HandmadePackProps) {
  const total = fallbackSlides.length
  const idx = clampIndex(activeIndex, total)
  const design = getDesign(draft, '#2457D6')
  const fonts = getSectorFonts('corporate')
  const copy = getCopy(draft, idx, fallbackSlides[idx])
  const visual = getVisual(draft, idx, images[idx % images.length], { overlay: 'white', opacity: 0.04, blur: false })

  const accent = design.accent || '#2457D6'
  const accent2 = design.accentDeep || '#0F172A'
  const background = '#F3F5F7'
  const surface = '#FFFFFF'
  const text = '#111827'
  const muted = 'rgba(17,24,39,0.56)'
  const border = 'rgba(17,17,17,0.14)'

  return (
    <HandmadeFrame activeIndex={idx} total={total} onActiveIndexChange={onActiveIndexChange} text={text}>

      <div className="absolute inset-0" style={{ background }} />
      {idx === 0 ? <FullBleedImage {...visual} /> : null}
      {idx === 0 ? <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(243,245,247,0.98), rgba(243,245,247,0.82), rgba(243,245,247,0.2))' }} /> : null}
      <div className="absolute inset-0" style={{ backgroundImage: 'linear-gradient(rgba(17,24,39,0.055) 1px, transparent 1px), linear-gradient(90deg, rgba(17,24,39,0.055) 1px, transparent 1px)', backgroundSize: '48px 48px' }} />
      <div className="absolute left-8 top-8 rounded-2xl px-3 py-2 text-[11px] font-black uppercase tracking-[0.18em]" style={{ color: '#fff', background: accent, fontFamily: fonts.label }}>{copy.eyebrow}</div>
      <div className="absolute bottom-9 left-8 right-8 grid grid-cols-[1.2fr_0.8fr] gap-6">
        <div><SafeText className="text-[clamp(34px,7.2vw,60px)] font-black leading-[0.94] tracking-[-0.055em]" style={{ color: text, fontFamily: fonts.heading }}>{copy.headline}</SafeText><SafeText className="mt-4 max-w-[390px] text-[16px] leading-[1.45]" style={{ color: muted, fontFamily: fonts.body }}>{copy.subheadline}</SafeText></div>
        <div className="rounded-[28px] border bg-white/82 p-5" style={{ borderColor: border }}><div className="text-[56px] font-black leading-none" style={{ color: accent, fontFamily: fonts.display }}>{idx + 1}</div>{copy.bullets.slice(0,3).map((item: string, i: number) => <div key={i} className="mt-3 border-t pt-3 text-[12px] font-bold" style={{ borderColor: border, color: text, fontFamily: fonts.label }}>{item}</div>)}</div>
      </div>

    </HandmadeFrame>
  )
}
